import { UserRoundIcon } from 'lucide-react';
import { useSite } from '../../contexts/SiteContext';
import { useCatalog } from '../../contexts/CatalogContext';
import { useOverlayActions } from '../../contexts/StoreContext';
import { founder } from '../../data/content';
import { staffList } from '../../core/rules/salonDays';
import { sectionHeading } from '../../ui/sections';

/**
 * "In de salon": de collega's naast Sarah, met foto, naam, alinea en welke behandelingen zij doet.
 * Beheerd in Instellingen › Team. Zonder actieve collega's: niets (Sarah staat al op de pagina).
 */
export function TeamSection() {
  const site = useSite();
  const {
    treatments
  } = useCatalog();
  const {
    openBooking
  } = useOverlayActions();
  const colleagues = staffList(site.staff).filter(s => s.role === 'staff' && s.active);
  if (colleagues.length === 0) return null;
  const doesList = (slugs: string[] | 'alle') => slugs === 'alle' ? 'Alle behandelingen' : treatments.filter(t => slugs.includes(t.slug)).map(t => t.name).join(' · ');
  return <section className="bg-shell py-20 sm:py-24" aria-labelledby="about-team" data-id="element-5627" data-mp="zjokjqukn6mk">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-5628" data-mp="14jb6qpsdnx7i">
        <h2 id="about-team" className={sectionHeading} data-id="element-5629" data-mp="14lxeapf9qcpq">
          Ook in de salon
        </h2>
        <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-muted" data-id="element-5630" data-mp="19gt7hsw8r64f">
          Op een paar dagen in de week behandelt een collega, op dezelfde manier en met dezelfde producten. {founder.firstName} blijft je huidplan volgen.
        </p>
        <ul className="mt-12 grid gap-12 md:grid-cols-2" data-id="element-5631" data-mp="lstf6oja77nq">
          {colleagues.map(s => {
          const does = doesList(s.allTreatments ? 'alle' : s.treatments);
          return <li key={s.id} className="grid grid-cols-[6rem_minmax(0,1fr)] gap-6 sm:grid-cols-[8rem_minmax(0,1fr)]" data-id="element-5632" data-mp="um6lcs6cw5rr">
                {s.photo ? <img src={s.photo} alt={`Portret van ${s.name}`} className="aspect-[4/5] w-full rounded-sm object-cover" loading="lazy" data-id="element-5633" data-mp="3u8wfuabz7w2k" /> : <span className="flex aspect-[4/5] w-full items-center justify-center rounded-sm bg-sand text-muted" aria-hidden="true" data-id="element-5634" data-mp="15fhus3ocelf8">
                    <UserRoundIcon className="h-8 w-8" strokeWidth={1.25} data-id="element-5635" data-mp="10gwszztfztoo" />
                  </span>}
                <div className="min-w-0" data-id="element-5636" data-mp="1f7vvct3oplzt">
                  <h3 className="font-display text-[1.6rem] font-light leading-tight text-ink" data-id="element-5637" data-mp="1a8158rrqh0ft">{s.name}</h3>
                  {s.intro && <p className="mt-1 text-[14px] text-ink" data-id="element-5638" data-mp="mhxdbhnwqp4n">{s.intro}</p>}
                  {s.bio && <p className="mt-3 whitespace-pre-line text-[15px] leading-relaxed text-muted" data-id="element-5639" data-mp="hjcbxewx5zem">{s.bio}</p>}
                  {does && <p className="mt-3 text-[13px] text-muted" data-id="element-5640" data-mp="vjn2shy8bdzs">{does}</p>}
                  <button type="button" onClick={() => openBooking()} aria-haspopup="dialog" className="mt-4 text-[14px] text-clay underline underline-offset-4 transition-colors duration-150 ease-soft hover:text-ink" data-id="element-5641" data-mp="rg8ktlqqcnjp">
                    Boek bij {s.name}
                  </button>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}